import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useGetInfoApi } from '@/api/notice';
import InputSearch from '@/components/common/Input/InputSearch/InputSearch';
import InputSelect from '@/components/common/Input/InputSelect/InputSelect';
import TablePagination from '@/components/common/Pagination/TablePagination';
import PostList from '@/components/common/PostList/PostList.tsx';
import BoardTable from '@/components/common/Table/BoardTable/BoardTable';
import * as S from '@/components/Information/InformationNotice/style';
import { SPONSORSHIP_MENU_ANNUAL_DONATION } from '@/constants/sponsorship';
import { tableOptions } from '@/constants/option';
import { generateColumns } from '@/constants/table';
import useDebounce from '@/hooks/useDebounce';
import useIsMobile from '@/hooks/useIsMobile';

const listNavigateState = { menu: SPONSORSHIP_MENU_ANNUAL_DONATION };

const SponsorshipAnnualDonation = () => {
	const navigate = useNavigate();
	const isMobile = useIsMobile(900);
	const [search, setSearch] = useState('');
	const [page, setPage] = useState(1);
	const [selectedOption, setSelectedOption] = useState('전체');
	const debouncedSearch = useDebounce(search, 300);

	const { data: infoData, isPending, isError, error } = useGetInfoApi({
		page,
		row: 10,
		search: debouncedSearch,
		search_category: selectedOption,
		type: 'donation',
	});

	const reports = infoData?.donation ?? [];
	const totalCount = infoData?.donation_count ?? 0;

	const handleRowOpen = (pk: number | string) => {
		navigate(`/sponsorship/donation/${pk}`, { state: listNavigateState });
	};

	return (
		<S.ConferenceContainer>
			<S.ConferenceBoardBox>
				<S.ConferenceSearchBox>
					<InputSelect options={tableOptions} selectedOption={selectedOption} setSelectedOption={setSelectedOption} />
					<InputSearch
						value={search}
						input={(e) => {
							setSearch(e.target.value);
							setPage(1);
						}}
						placeholder="검색어 입력"
					/>
				</S.ConferenceSearchBox>

				{isPending ? (
					<S.NoData>불러오는 중입니다.</S.NoData>
				) : isError ? (
					<S.NoData>목록을 불러오지 못했습니다. {error?.message ?? ''}</S.NoData>
				) : reports.length > 0 ? (
					!isMobile ? (
						<TablePagination activePage={page} totalItems={totalCount} onChange={(nextPage) => setPage(nextPage)}>
							<BoardTable
								columns={generateColumns(reports)}
								page={page}
								data={reports}
								totalItems={totalCount}
								onClick={handleRowOpen}
							/>
						</TablePagination>
					) : (
						<TablePagination activePage={page} totalItems={totalCount} onChange={(nextPage) => setPage(nextPage)}>
							<PostList data={reports} sort="donation" />
						</TablePagination>
					)
				) : (
					<S.NoData>등록 내역이 없습니다.</S.NoData>
				)}
			</S.ConferenceBoardBox>
		</S.ConferenceContainer>
	);
};

export default SponsorshipAnnualDonation;
